import { Card, Stack, Typography } from "@mui/material";
import { ActionButton, Flex } from "@zfp-akademie-a-s/zfp-design";
import { DeleteIcon } from "@zfp-akademie-a-s/zfp-design/icons";
import { AnalysisDetailContext } from "Components/Analyses/Detail/AnalysisDetailContext";
import type { PersonPickerPerson } from "Components/_Shared/Inputs/PersonPicker/personPickerPersons";
import { FormPersonPicker } from "Forms/Components/FormPersonPicker";
import type { IncomeBulkFormType } from "Forms/Schemas/Budget/Incomes/incomeBulkFormSchema";
import type { IncomeIncomeType } from "Infrastructure/ApiZfp/Schema";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { type FC, useContext } from "react";
import { useFormContext } from "react-hook-form";
import { IncomeDraftFields } from "./IncomeDraftFields";

type Props = {
  readonly index: number;
  readonly guid?: string;
  readonly incomeType: IncomeIncomeType;
  readonly persons: PersonPickerPerson[];
  readonly isReadOnly: boolean;
  readonly onRemove: () => void;
};

export const IncomeDraftCard: FC<Props> = ({ index, guid, incomeType, persons, isReadOnly, onRemove }) => {
  const { t } = useResource();
  const { readOnly } = useContext(AnalysisDetailContext);
  const {
    control,
    formState: { errors },
  } = useFormContext<IncomeBulkFormType>();

  const draftErrors = errors.drafts?.[index];
  const isDisabled = readOnly || isReadOnly;
  const removeLabel = t(Resources.AnalysisDetail.Budget.Incomes.Form.Buttons.RemoveItem);

  return (
    <Card data-income-guid={guid} data-invalid={!!draftErrors} sx={draftErrors ? { borderColor: "error.main" } : undefined}>
      <Stack spacing={Spacing.L} p={Spacing.XL}>
        <Flex justifyContent="space-between" alignItems="flex-start" gap={Spacing.M}>
          <FormPersonPicker
            control={control}
            name={`drafts.${index}.clientGuid`}
            persons={persons}
            caption={t(Resources.AnalysisDetail.Budget.Incomes.IncomeBelongsToCaption)}
            required
            disabled={isDisabled}
          />

          {!isDisabled && (
            <ActionButton label={removeLabel} icon={<DeleteIcon />} tone="danger" onClick={onRemove} sx={{ flexShrink: 0 }} />
          )}
        </Flex>

        {draftErrors?.message && (
          <Typography variant="body2" color="error.main">
            {draftErrors.message}
          </Typography>
        )}

        <IncomeDraftFields index={index} incomeType={incomeType} disabled={isDisabled} />
      </Stack>
    </Card>
  );
};
